const PedestrianStatisticsActionTypes = {
  SET_GENERAL_STATS: "pedestrianStatistics/SET_GENERAL_STATS",
  SET_DETAILS_STATS: "pedestrianStatistics/SET_DETAILS_STATS",
  SET_DAILY_ATTENDANCE_STATS: "pedestrianStatistics/SET_DAILY_ATTENDANCE_STATS",
  SET_LOADING: "pedestrianStatistics/SET_LOADING",
  SET_AUTO_REFRESH: "pedestrianStatistics/SET_AUTO_REFRESH",
  SET_INITIALIZED: "pedestrianStatistics/SET_INITIALIZED",
  SET_MAP_INFOS: "pedestrianStatistics/SET_MAP_INFOS",
  SET_SELECTED_LAYERS: "pedestrianStatistics/SET_SELECTED_LAYERS",
  SET_FILTER: "pedestrianStatistics/SET_FILTER",
  SET_FILTERS: "pedestrianStatistics/SET_FILTERS",
  SET_CONFIG: "pedestrianStatistics/SET_CONFIG",
  ERROR_ON_RETRIEVE: "pedestrianStatistics/ERROR_ON_RETRIEVE",
  REMOVE_ERROR: "pedestrianStatistics/REMOVE_ERROR",
  SET_AFFLUENCE_CHART_TIME_RANGE_BY_DAY:
    "pedestrianStatistics/SET_AFFLUENCE_CHART_TIME_RANGE_BY_DAY",
  SET_QUEUE_LOADING: "pedestrianStatistics/SET_QUEUE_LOADING",
  SET_QUEUE_DETAILS_STATS: "pedestrianStatistics/SET_QUEUE_DETAILS_STATS",
  SET_QUEUE_DAILY_ATTENDANCE_STATS:
    "pedestrianStatistics/SET_QUEUE_DAILY_ATTENDANCE_STATS",
  SET_QUEUE_DAILY_WAITING_TIME_STATS:
    "pedestrianStatistics/SET_QUEUE_DAILY_WAITING_TIME_STATS",
  SET_QUEUE_DAILY_ATTENDANCE_MAX_STATS:
    "pedestrianStatistics/SET_QUEUE_DAILY_ATTENDANCE_MAX_STATS",
  SET_QUEUE_DETAILS_STATS_ERROR:
    "pedestrianStatistics/SET_QUEUE_DETAILS_STATS_ERROR",
  SET_QUEUE_DAILY_ATTENDANCE_STATS_ERROR:
    "pedestrianStatistics/SET_QUEUE_DAILY_ATTENDANCE_STATS_ERROR",
  SET_QUEUE_DAILY_WAITING_TIME_STATS_ERROR:
    "pedestrianStatistics/SET_QUEUE_DAILY_WAITING_TIME_STATS_ERROR",
  SET_QUEUE_DAILY_ATTENDANCE_MAX_STATS_ERROR:
    "pedestrianStatistics/SET_QUEUE_DAILY_ATTENDANCE_MAX_STATS_ERROR",
};

export default PedestrianStatisticsActionTypes;
